import type {ReactElement} from 'react';
import React, {useContext} from 'react';
import {EventStyle} from '@Components/event-wizard/event-style';
import {EventWizardDateTime} from '@Components/event-wizard/event-wizard-date-time';
import {EventWizardVenue} from '@Components/event-wizard/event-wizard-venue';
import {NameInput} from '@Components/event-wizard/name-input';
import type {EventWizardDetailsProps} from '@Components/event-wizard/event-wizard-details/event-wizard-details.types';
import {EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT} from '@Components/event-wizard/event-wizard-container-queries-context';
import {useEventWizardIsDesignPrefillContentLoading} from '@Components/event-wizard/event-wizard.hooks';
import {SkeletonBrick} from '@Components/skeleton-brick';

export function EventWizardDetails({isForReviewPage = false}: EventWizardDetailsProps): ReactElement<any> {
  const isPrefillContentLoading = useEventWizardIsDesignPrefillContentLoading();

  const {isSmallScreen} = useContext(EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT);
  const spacingBottom = isSmallScreen ? 'spacing-m-b-2' : 'spacing-m-b-4';

  const getBodyContent = (): ReactElement<any> => {
    return (
      <>
        <div className={`${spacingBottom} _full-width`}>
          <NameInput />
        </div>

        <div className={`${spacingBottom} _full-width`}>
          <EventWizardDateTime />
        </div>

        <div className={`${spacingBottom} _full-width`}>
          <EventWizardVenue />
        </div>

        <div className={`${spacingBottom} _full-width`}>
          <EventStyle />
        </div>
      </>
    );
  };

  const getLoadingView = (): ReactElement<any> => {
    return (
      <div className="flex-column-justify-center">
        <SkeletonBrick className="spacing-m-b-6" width={100} height={24} />
        <SkeletonBrick className="spacing-m-b-8 _full-width" height={40} />
        <SkeletonBrick className="spacing-m-b-6" width={100} height={24} />
        <SkeletonBrick className="spacing-m-b-8 _full-width" height={40} />
        <SkeletonBrick className="spacing-m-b-6" width={100} height={24} />
        <SkeletonBrick className="spacing-m-b-8 _full-width" height={40} />
      </div>
    );
  };

  return (
    <>
      {!isForReviewPage && !isSmallScreen ? <h4 className="heading-h4 spacing-p-0 content-body spacing-m-b-4">{window.i18next.t('pmwjs_create_your_event')}</h4> : undefined}
      {isPrefillContentLoading ? getLoadingView() : getBodyContent()}
    </>
  );
}
